export default {
    NOT_APPLICABLE: 0
}